//export const locales = ['en', 'es', 'ja', 'de', 'fr', 'zh', 'ko'] as const;
export const locales = ['en','de'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  //zh: '中文',
  //ko: '한국어',
  //es: 'Español',
  //ja: '日本語',
  de: 'Deutsch',
  //fr: 'Français',
};
